import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function parametrosService() {
  const api = useApi()

  function getParametros(params) {
    return api.query(`${URLS.parametros}${params || ''}`)
  }

  function patchParametros(id, data) {
    return api.mutation(`${URLS.parametros}/${id}/`, 'PATCH', data)
  }

  return {
    getParametros,
    patchParametros,
    ...api,
  }
}
